import get from "lodash.get";

import paths from "routes/paths";
import AbstractApi from "services/cores/abstractApi";
import XHTTP from "services/api/xhttp";
import { XHTTPBlob } from "services/api/xhttp";

class IndicatorsApi extends AbstractApi {
  retrieveIndicators = (data, filters = {}) => {
    return XHTTP(`${get(this.config, "paths.default", "")}`, {
      method: "post",
      body: JSON.stringify({ ...filters, config: data }),
    });
  };

  downloadIndicators = (data) => {
    return XHTTPBlob(`${get(this.config, "paths.download", "")}`, {
      method: "post",
      body: JSON.stringify(data),
    });
  };
}

export default new IndicatorsApi({
  paths: {
    default: paths.api.indicators.default,
    download: paths.api.indicators.download,
  },
});
